import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Clock, LogOut, RefreshCw } from "lucide-react";

export default function PendingApproval() {
  const { user, logout, refresh, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login"); return; }
    if (user.role === "admin") navigate("/admin");
    else if (user.status === "approved") navigate("/portal");
    else if (user.status === "pending_onboarding") navigate("/onboarding");
  }, [user, loading, navigate]);

  const rejected = user?.status === "rejected";

  return (
    <div className="min-h-screen bg-[#050505] text-white grid-noise flex items-center justify-center p-6">
      <div className="max-w-lg w-full border border-[#2A2A2A] bg-[#111111] p-10 text-center">
        <div className={`w-16 h-16 mx-auto flex items-center justify-center border mb-6 ${rejected ? "border-[#EF4444] text-[#EF4444]" : "border-[#F59E0B] text-[#F59E0B]"}`}>
          <Clock className="w-8 h-8" />
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-[#FF4D00] mb-3">Onboarding Gate</div>
        <h1 className="font-bebas text-5xl mb-4">{rejected ? "APPLICATION DECLINED" : "AWAITING APPROVAL"}</h1>
        <p className="text-sm text-[#A1A1AA] leading-relaxed mb-8">
          {rejected
            ? "Your onboarding was not approved. Please contact the Splash team for next steps."
            : "Your documents have been submitted. An admin is reviewing your application. You'll gain access to the portal once approved."}
        </p>
        <div className="flex gap-3 justify-center">
          <button data-testid="pending-refresh-btn" onClick={refresh} className="inline-flex items-center gap-2 border border-[#2A2A2A] px-5 py-3 text-sm hover:bg-[#1A1A1A] transition-colors"><RefreshCw className="w-4 h-4" /> Check status</button>
          <button data-testid="pending-logout-btn" onClick={async () => { await logout(); navigate("/login"); }} className="inline-flex items-center gap-2 bg-[#FF4D00] text-white px-5 py-3 text-sm hover:bg-[#E64500] transition-colors"><LogOut className="w-4 h-4" /> Sign out</button>
        </div>
      </div>
    </div>
  );
}
